import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
})
export class TextComponent implements OnInit {
  @Input() data: any;
  safeHtml: SafeHtml = '';
  constructor(public sanitizer: DomSanitizer) { }
  ngOnInit(): void {
    if (this.data?.text_body?.value) {
      this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.data.text_body.value);
    }
  }
}
